/// <reference path="../../_ext/Editors/EditorDialogBase.ts" />

namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.maximizable(false)
    export class ReceiptDetailsDialog extends _Ext.ItemEditorDialog<ReceiptDetailsRow> {
        protected getFormKey() { return ReceiptDetailsForm.formKey; }
        protected getLocalTextPrefix() { return ReceiptDetailsRow.localTextPrefix; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        protected form = new ReceiptDetailsForm(this.idPrefix);
        public exchangerate;
        constructor() {
            super(); 
            q.setTextRightAlign(this.form.Amount);
            //q.setTextRightAlign(this.form.Total);
            //q.setTextRightAlign(this.form.Balance);
            q.hideEditorLabel(this.form.Denominations);
            q.hideEditorToolbar(this.form.Denominations);
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 350;
            q.initReceiptEditor(this, this.form.Denominations, Config);
            this.form.Mode.changeSelect2(e => {
                var ledger = OMS.PaymentModeRow.getLookup().itemById[this.form.Mode.value];
                this.form.LedgerId.value = ledger.LedgerId.toString();

                Serenity.EditorUtils.setReadOnly(this.form.LedgerId, true);
                if (ledger.Type == 280) { //For Cash
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                    q.hideField(this.form.RefNo, true);
                    q.showField(this.form.Denominations);
                    this.form.Denominations.setData();
                }
                else if (ledger.Type == 283) { //For Gift Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                    q.hideField(this.form.RefNo, false);
                    q.hideField(this.form.Denominations);
                }
                else if (ledger.Type == 281) {//For Cheque
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                    q.hideField(this.form.ChequeDate, false);
                    q.hideField(this.form.ChequeNo, false);
                    q.hideField(this.form.BankId, false);
                    q.hideField(this.form.RefNo, true);
                    q.hideField(this.form.Denominations);
                }
                else
                    q.hideField(this.form.Denominations);
                this.form.RefNo.value = "";

            });
            this.form.RefNo.changeSelect2(e => {
                var details = GiftVoucherItemDetailsRow.getLookup().items.filter(x => x.UniqueNo == this.form.RefNo.value);
                amount = 0;
                for (var i = 0; i < details.length; i++) {
                    amount += details[i].Amount;
                }
                this.form.Amount.value = amount;
                if (details[0].IsPartial) {

                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                } else { Serenity.EditorUtils.setReadOnly(this.form.Amount, false); }
            });
            this.form.Amount.changeSelect2(e => {
                if (this.form.Mode.value == "283") {
                    if (this.form.Amount.value > amount) {
                        Q.alert('Gift Voucher Limit Exceded');
                        this.form.Amount.value = amount;
                        return;
                    }
                }
            });
            //this.form.Scheme.changeSelect2(e => {
            //    var schemedetails = Scheme.SchemeEnrollmentRow.getLookup().itemById[this.form.Scheme.value];
            //    var totalamount = schemedetails.SchemeAmount + schemedetails.BonusValue;
            //    this.form.Amount.value = totalamount;
            //});
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.Mode.value != "") {
                var ledger = OMS.PaymentModeRow.getLookup().itemById[this.form.Mode.value];
                this.form.LedgerId.value = ledger.LedgerId.toString();

                Serenity.EditorUtils.setReadOnly(this.form.LedgerId, true);
                if (ledger.Type == 280) { //For Cash
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                    q.hideField(this.form.RefNo, true);
                    q.showField(this.form.Denominations); 
                }
                else if (ledger.Type == 283) { //For Gift Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                    q.hideField(this.form.RefNo, false);
                    q.hideField(this.form.Denominations);
                }
                else if (ledger.Type == 281) {//For Cheque
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                    q.hideField(this.form.ChequeDate, false);
                    q.hideField(this.form.ChequeNo, false);
                    q.hideField(this.form.BankId, false);
                    q.hideField(this.form.RefNo, true);
                    q.hideField(this.form.Denominations);
                }
                else
                    q.hideField(this.form.Denominations);


            } else {
               // q.hideField(this.form.Scheme, true);
                q.hideField(this.form.ChequeNo, true);
                q.hideField(this.form.ChequeDate, true);
                q.hideField(this.form.BankId, true);
            }
        }


        setAmount() {
            var denominations = this.form.Denominations.getItems();
            var amount = 0;
            for (var i = 0; i < denominations.length; i++) {
                if (denominations[i].Amount != null)
                    amount += denominations[i].Count * denominations[i].Code;
            }
            this.form.Amount.value = amount;
        }
        validateBeforeSave() {
            var returnvalue = super.validateBeforeSave();
            var amount = this.form.Amount.value; 
            //if (amount > balance) {
            //    q.Alert('', 'Amount cannot be greater than Balance', 2999, true);
            //    returnvalue = false;
            //    return returnvalue;
            //}
            if (returnvalue) {
                var ledger = OMS.PaymentModeRow.getLookup().itemById[this.form.Mode.value];
                if (ledger.Type == 280) {
                    var denominations = this.form.Denominations.getItems();

                    for (var i = 0; i < denominations.length; i++) {
                        if (denominations[i].Amount == null) {
                            denominations[i].Amount = 0;
                            denominations[i].Count = 0;
                        }
                    }
                }
            }
            return returnvalue;
        }
    }
}